import { render, staticRenderFns } from "./ZahnwerkstattCaseExamplesPage.vue?vue&type=template&id=253b64eb&scoped=true"
import script from "./ZahnwerkstattCaseExamplesPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattCaseExamplesPage.vue?vue&type=script&lang=js"
import style0 from "./ZahnwerkstattCaseExamplesPage.vue?vue&type=style&index=0&id=253b64eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253b64eb",
  null
  
)

export default component.exports